var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 11.35c1.18.38 2 1.5 2 2.8v5.7a2.9 2.9 0 0 1-2.64 2.93l-1.36.1V27l-4-4c-1.79 0-3.58-.07-5.36-.22a2.82 2.82 0 0 1-1.1-.32M27 11.35c-.2-.07-.42-.11-.63-.13-3.58-.3-7.16-.3-10.74 0A2.9 2.9 0 0 0 13 14.14v5.72c0 1.11.61 2.1 1.54 2.6M27 11.35v-2.5a4.3 4.3 0 0 0-3.68-4.31 64.6 64.6 0 0 0-16.64 0A4.3 4.3 0 0 0 3 8.84v8.31a4.3 4.3 0 0 0 3.68 4.31c.77.1 1.54.2 2.32.26V28l5.54-5.54",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.db4eeb2ee620227589c7a969e9641d78.svg";
export { ForwardRef as ReactComponent };